/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teary_Vivid_Finch_FearInputs */

const fr_teary_vivid_finch_fear = /** @type {(inputs: Teary_Vivid_Finch_FearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

/**

* @param {Teary_Vivid_Finch_FearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teary_vivid_finch_fear = /** @type {((inputs?: Teary_Vivid_Finch_FearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teary_Vivid_Finch_FearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teary_vivid_finch_fear(inputs)
});